import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid2,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  FormControlLabel,
  DialogActions,
  useMediaQuery
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import MuiCheckBox from "../../../components/CommonReusableComponent/MuiCheckbox/MuiCheckBox";
import { getAllActivityList } from "../../../helpers/api-functions-helper";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import {
  SNACKBAR_VARIANT,
  ERROR_MESSAGE,
} from "../../../config/Messages.config";
import MUILoader from "../../../components/MUILoader/MUILoader";
import { AppTheme } from "../../../theme/App.theme";
import MUITableSearch from "../../../components/MUITable/MUITableSearch";
import { handleOutSideDataTableSearch } from "../../../common/MuiTableFunctions.config";
import { getUserRoleAndScreens } from "../../../services/authServices/auth.services";

const AddOrUpdateActivityListModal = ({
  Open,
  ToggleDialogBox,
  Title,
  MandatoryActivityList,
  SetActivityListModalData,
  RecentSelectedActivityList,
  IsUpdateMode
}) => {
  const { showSnackbar } = useSnackbar();
  const { accountId } = getUserRoleAndScreens();
  const isSmallScreen = useMediaQuery("(max-width:500px)");
  const increaseWidth = useMediaQuery("(max-width:405px)");
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [All_Activity, set_All_Activity_Points] = useState([]);
  const [activityListInstance, setActivityListInstance] = useState([]);
  const [searchText, setSearchText] = useState("");

  const countDivStyle = {
    width: !increaseWidth ? "40px" : "45px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: AppTheme.PRIMARY_COLOR_LIGHT,
  };

  // Function to fetch all check list points
  const fetchAllActivityList = () => {
    setIsPageLoading(true);
    getAllActivityList(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data, message } = response.data;
          if (statusCode && statusCode === 200) {
            const filteredActivityList =
            data && data[0]
            ? data.filter((obj) =>
                !MandatoryActivityList.some((mandatory) => mandatory.id === obj.id)
              )
              .map((item) => ({
                ...item,
                selected: RecentSelectedActivityList.some(
                  (recent) => recent.id === item.id
                ),
                isMandatory: false,
              }))
            : [];
            console.log("RecentSelectedActivityList-->", RecentSelectedActivityList)
            set_All_Activity_Points([...filteredActivityList]);
            setActivityListInstance([...filteredActivityList]);
          } else {
            showSnackbar(
              message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
              SNACKBAR_VARIANT.ERROR
            );
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsPageLoading(false);
      });
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchAllActivityList();
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Search functionality
  useEffect(() => {
    if (searchText === "") {
      // Reset to original data if search text is cleared
      set_All_Activity_Points(activityListInstance);
    } else {
      const filteredData_ = handleOutSideDataTableSearch(
        searchText,
        activityListInstance
      );
      set_All_Activity_Points(filteredData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  // Function used to select/de-select checkboxes
  const handleCheckboxChange = (event, activityList) => {
    const { checked } = event.target;
    set_All_Activity_Points((prev) =>
      prev.map((item) =>
        item.id === activityList.id ? { ...item, selected: checked } : item
      )
    );
    setActivityListInstance((prev) =>
      prev.map((item) =>
        item.id === activityList.id ? { ...item, selected: checked } : item
      )
    );
  };

  // Function used to handle add or update checklist
  const handleAddUpdateCheckPoints = () => {
    const final_data = [...activityListInstance]
      .filter((activity) => activity.selected)
      .map((obj) => {
        return {
          id: obj.id,
          name: obj.name,
          selected: true,
          isMandatory: false,
        };
      });
    // console.log("final data: ", final_data);
    SetActivityListModalData(final_data);
    ToggleDialogBox("activityList");
  };

  return (
    <Dialog
      open={Open}
      disableEscapeKeyDown={true}
      maxWidth="md"
      disableEnforceFocus={true}
      fullWidth
      slotProps={{
        style: {
          opacity: 0.7,
        },
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <div className="d-flex align-items-center">
          <Typography
            className="inter-medium-500"
            style={{
              fontSize: "18px",
            }}
          >
            {Title}
          </Typography>
          <div
            className={
              isSmallScreen
                ? "ms-auto d-flex align-items-center text-center me-2"
                : "ms-auto d-flex align-items-center text-center me-4"
            }
            style={countDivStyle}
          >
            <Typography
              variant="body1"
              style={{ color: AppTheme.PRIMARY_COLOR }}
              className="inter-regular-400 w-100"
            >
              {activityListInstance.filter((obj) => obj.selected).length}
            </Typography>
          </div>
          <IconButton
            aria-label="close"
            className="p-2"
            onClick={() => ToggleDialogBox("activityList")}
            style={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icons.Close />
          </IconButton>
        </div>
        <div className="pt-1">
          <MUITableSearch
            CancelSearch={() => {
              setSearchText("");
            }}
            HandleSearch={(e) => setSearchText(e.target.value)}
            SearchText={searchText}
          />
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div>
          <Grid2 container spacing={2} className="mb-2">
            {isPageLoading ? (
              <MUILoader IsMiniLoader={true} />
            ) : (
              <>
                {All_Activity[0] ? (
                  All_Activity.map((activity, id) => {
                    return (
                      <Grid2
                        size={12}
                        key={id}
                        style={{
                          backgroundColor: AppTheme.MUTED_LIGHT,
                          borderRadius: "5px",
                        }}
                        className="m-1 p-1"
                      >
                        <FormControlLabel
                          className="ps-3"
                          style={{
                            height: "fit-content",
                          }}
                          control={
                            <MuiCheckBox
                              Color={activity.isMandatory && AppTheme.MUTED}
                              Disabled={activity.isMandatory}
                              OnChange={(event) =>
                                handleCheckboxChange(event, activity)
                              }
                              Value={activity.name}
                              Checked={activity.selected}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              className="inter-regular-400"
                            >
                              {activity.name}
                            </Typography>
                          }
                        />
                      </Grid2>
                    );
                  })
                ) : (
                  <Grid2 size={12}>
                    <Typography
                      variant="body2"
                      className="inter-regular-400 mt-2"
                      align="center"
                    >
                      There are no records to display.
                    </Typography>
                  </Grid2>
                )}
              </>
            )}
          </Grid2>
        </div>
      </DialogContent>
      <DialogActions>
        <Grid2 container spacing={2} className="p-2 w-100">
          <AppButton OnPress={handleAddUpdateCheckPoints}>
            {IsUpdateMode ? "Update" : "Add"}
          </AppButton>
        </Grid2>
      </DialogActions>
    </Dialog>
  );
};

export default AddOrUpdateActivityListModal;
